module.exports = __webpack_public_path__ + "a680dcdaa6873cd2eb833d83c102c5d0.MP3";